import { render, staticRenderFns } from "./FileOptions.vue?vue&type=template&id=782ab135&"
import script from "./FileOptions.vue?vue&type=script&lang=js&"
export * from "./FileOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('782ab135')) {
      api.createRecord('782ab135', component.options)
    } else {
      api.reload('782ab135', component.options)
    }
    module.hot.accept("./FileOptions.vue?vue&type=template&id=782ab135&", function () {
      api.rerender('782ab135', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/docDigital/components/FileOptions.vue"
export default component.exports